export const ownerPackets = [
    {
      label: "Owner Statement",
      children: [
        {
          title: 'Transactions',
          value: 'Transactions',
        },
        {
          title: 'Unpaid Bills',
          value: 'Unpaid Bills',
        },
        {
            title: 'Tenant Names',
            value: 'Tenant Names',
        },
      ],
    },
  ];

  export const properties = [
    "test 1",
    "test 2",
    "test 3"
  ];